module.exports = __webpack_public_path__ + "static/media/Q_1.27a5381d.png";